import React, { memo, useMemo, useState } from "react";

import { buildCardFallbackImage } from "../characterCreatorUtils.js";

const ChoiceCard = memo(function ChoiceCard({
  className = "",
  selected = false,
  locked = false,
  imageUrl,
  imageLabel,
  imageVertical = false,
  badge,
  onClick,
  children,
}) {
  const [failed, setFailed] = useState(false);
  const fallbackImage = useMemo(
    () => buildCardFallbackImage(imageLabel || "World Hub RPG"),
    [imageLabel]
  );

  const cardClassName = [
    "pick-card",
    className,
    selected ? "selected" : "",
    locked ? "locked" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={cardClassName} onClick={locked ? undefined : onClick}>
      {badge}
      {imageUrl ? (
        <div className={`card-media${imageVertical ? " card-media--vertical" : ""}`}>
          <img
            src={failed ? fallbackImage : imageUrl}
            alt={imageLabel || "Imagem temática"}
            loading="lazy"
            onError={() => setFailed(true)}
          />
          <span className="card-media-shadow" aria-hidden="true"></span>
        </div>
      ) : null}
      {children}
    </div>
  );
});

export default ChoiceCard;
